import React from 'react';
import { X, Loader2, Download } from 'lucide-react';

export const isImage = (ct) => (ct || '').startsWith('image/');
export const isPdf = (ct) => ct === 'application/pdf';
export const isPreviewable = (ct) => isImage(ct) || isPdf(ct);

export const FilePreviewModal = ({ filename, contentType, url, onClose, onDownload, testId = 'file-preview' }) => (
  <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid={testId}>
    <div className="bg-white rounded-sm w-full max-w-4xl h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
      <div className="bg-[#1B3A5C] text-white px-5 py-3 flex items-center justify-between gap-3">
        <p className="text-sm truncate" data-testid={`${testId}-title`}>{filename}</p>
        <div className="flex items-center gap-1 flex-shrink-0">
          {onDownload && (
            <button onClick={onDownload} className="hover:bg-white/10 p-1.5 rounded" title="Herunterladen" aria-label="Herunterladen" data-testid={`${testId}-download`}><Download className="w-4 h-4" /></button>
          )}
          <button onClick={onClose} className="hover:bg-white/10 p-1.5 rounded" aria-label="Schließen" data-testid={`${testId}-close`}><X className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="flex-1 bg-[#e9eef2] overflow-auto flex items-center justify-center">
        {!url ? (
          <Loader2 className="w-8 h-8 text-[#b8893d] animate-spin" />
        ) : isImage(contentType) ? (
          <img src={url} alt={filename} className="max-w-full max-h-full object-contain" />
        ) : (
          <iframe title={filename} src={url} className="w-full h-full" />
        )}
      </div>
      {url && (
        <div className="px-5 py-2 border-t border-gray-100 text-right">
          <button onClick={() => window.open(url, '_blank')} className="text-xs text-[#1B3A5C] hover:text-[#b8893d] tracking-wider" data-testid={`${testId}-newtab`}>IN NEUEM TAB ÖFFNEN</button>
        </div>
      )}
    </div>
  </div>
);

export default FilePreviewModal;
